import type { ApiHandlerOptions, ApiHandlerType, FetchFunction } from '@boozt/modules/api/types';

export const handler: ApiHandlerType = {
    endpoint: null!,
    active: null!,
    custom: false,
    options: {
        onBeforeFetch: () => {},
    },
};

export const setFetchHandler = async (
    endpoint: string,
    fetchHandler: FetchFunction,
    options: ApiHandlerOptions | null = null,
    isCustom: boolean = false,
): Promise<void> => {
    handler.endpoint = endpoint;
    handler.active = fetchHandler;
    handler.custom = isCustom;

    if (options) {
        handler.options = options;
    }
};
